import React, { useMemo, useState } from 'react';
import { DataType, DeptItem } from '@fx-ui/jdy-design-biz';
import { ContactValuePanel, DeptSelectDialog, getContactDeptList } from '@fx-ui/platform-sdk';
import { useStores } from '~/hooks';
import { makeArray } from '@libs/shared';

interface MemberFieldDeptProps {
    className?: string;
    style?: React.CSSProperties;
    value?: DeptItem | DeptItem[] | null | undefined;
    onChange?: (value: DeptItem | DeptItem[] | null | undefined) => void;
    multiple?: boolean;
    autoPop?: boolean;
    disabled?: boolean;
    onClose?: () => void;
    disabledIds?: string[];
}

const MemberFieldDept: React.FC<MemberFieldDeptProps> = (props) => {
    const {
        className,
        style,
        value,
        onChange,
        multiple = true,
        autoPop = false,
        disabled,
        onClose,
        disabledIds
    } = props;

    const [visible, setVisible] = useState(autoPop);

    const { corpUserStore } = useStores();

    const fixValue = useMemo(() => makeArray(value), [value]);

    const handleClose = () => {
        setVisible(false);
        onClose?.();
    };

    return (
        <>
            <ContactValuePanel
                style={multiple ? style : { ...style, height: '42px' }}
                disabled={disabled}
                className={className}
                dataType={DataType.dept}
                items={fixValue}
                onClick={() => setVisible(true)}
            />
            {!disabled && (
                <DeptSelectDialog
                    disabledIds={disabledIds}
                    multiple={multiple}
                    visible={visible}
                    value={fixValue}
                    onFetchInternalDepartments={(p) =>
                        getContactDeptList(corpUserStore.tenantId, { ...p, hasCount: true })
                    }
                    onCancel={handleClose}
                    onOk={(depts) => {
                        if (multiple) {
                            onChange?.(depts ?? []);
                        } else {
                            onChange?.(depts?.[0] ?? null);
                        }
                        handleClose();
                    }}
                />
            )}
        </>
    );
};

export default MemberFieldDept;
